var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04896 3.92664C9.34833 3.00537 10.6517 3.00538 10.951 3.92664L12.0208 7.21864C12.1547 7.63063 12.5386 7.90957 12.9718 7.90958L16.4333 7.90971C17.402 7.90975 17.8047 9.1493 17.0211 9.71871L14.2208 11.7534C13.8703 12.008 13.7237 12.4594 13.8575 12.8714L14.927 16.1635C15.2263 17.0847 14.1719 17.8508 13.3882 17.2815L10.5878 15.247C10.2373 14.9924 9.76272 14.9924 9.41225 15.247L6.61179 17.2815C5.82809 17.8508 4.77367 17.0847 5.07297 16.1635L6.14249 12.8714C6.27634 12.4594 6.1297 12.008 5.77924 11.7534L2.97894 9.71871C2.19528 9.1493 2.59804 7.90975 3.56672 7.90971L7.02818 7.90958C7.46137 7.90957 7.8453 7.63063 7.97918 7.21864L9.04896 3.92664Z",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_1986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.dd261053203e45c360c59fbc633dbec5.svg";
export { ForwardRef as ReactComponent };